export default __webpack_public_path__ + "img/no-minors.e58f7606.svg";